import { ErrorDisplay } from '../../../../Shared/components/ErrorDisplay/ErrorDisplay';
import { ApiError } from '../../../../Shared/interfaces/ApiError';
import { UserInterface } from '../../../../Shared/interfaces/user/UserInterfaces';
import { SearchSuggestion } from '../../../../UiComponentsLibrary/CustomSearchInput';
import CustomSpinner from '../../../../UiComponentsLibrary/CustomSpinner';
import Pagination from './Pagination';
import SearchAndPagination from './SearchAndPagination';
import TableOrNoData from './Table';

const MainContent = ({
  isError,
  error,
  isLoading,
  getUsersData,
  handleDataTableAction,
  renderPaginationProps,
  renderSearchAndPaginationProps,
}: {
  isError: boolean;
  error: ApiError | null;
  isLoading: boolean;
  getUsersData: UserInterface[];
  handleDataTableAction: (actionType: string, row: UserInterface) => void;
  renderPaginationProps: {
    currentPage: number;
    currentSize: number;
    totalItems: number;
    handlePageChange: (page: number) => void;
  };
  renderSearchAndPaginationProps: {
    handleSearchChange: (value: string) => void;
    searchValue: string;
    currentSize: number;
    handlePageChange: (page: number) => void;
    handlePageSizeChange: (size: number) => void;
    searchSuggestions: SearchSuggestion[];
  };
}) => {
  if (isError)
    return (
      <div id="user-management-api-error">
        <ErrorDisplay error={error as ApiError} />
      </div>
    );
  if (isLoading)
    return (
      <div id="user-management-spinner">
        <CustomSpinner />
      </div>
    );

  return (
    <>
      <SearchAndPagination {...renderSearchAndPaginationProps} />
      <TableOrNoData
        usersData={getUsersData}
        handleDataTableAction={handleDataTableAction}
      />
      <Pagination {...renderPaginationProps} />
    </>
  );
};

export default MainContent;
